<template>
    <b-container fluid>
        <div>
            <b-row class="justify-content-start">
                <b-col cols="3">
                    <b-btn
                        title="volver"
                        variant="primary"
                        @click="$router.push({ name: 'clientsPage' })"
                    >
                        <i class="fa fa-arrow-left"></i>
                    </b-btn>
                </b-col>
            </b-row>
            <br />
            <b-row class="justify-content-start">
                <b-col>
                    <h4>
                        <label>
                            Datos adicionales del cliente prospecto
                            {{ clientName }}
                        </label>
                    </h4>
                </b-col>
            </b-row>
            <b-card class="text-center">
                <b-row>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            size="sm"
                            label="Nombre de contacto principal"
                            v-model="commercialInfo.mainContact"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            size="sm"
                            type="text"
                            label="Cargo"
                            v-model="commercialInfo.workPosition"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="deliveryDate">Fecha probable de inicio</label>
                        <b-form-input
                            id="deliveryDate"
                            size="sm"
                            type="date"
                            v-model="commercialInfo.probableStartDate"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="deliveryDate">Entrega de propuesta</label>
                        <b-form-input
                            id="deliveryDate"
                            size="sm"
                            type="date"
                            v-model="commercialInfo.proposalDeliveryDate"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="reason">Motivo dominante de compra</label>
                        <app-form-textarea-input
                            id="reason"
                            size="sm"
                            v-model="commercialInfo.reasonForPurchase"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="management">Resumen de la gestion realizada</label>
                        <app-form-textarea-input
                            size="sm"
                            id="management"
                            v-model="commercialInfo.managementPerformed"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="nextStep">Siguiente paso en el proceso</label>
                        <app-form-textarea-input
                            id="nextStep"
                            size="sm"
                            v-model="commercialInfo.nextStepProcess"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="objetives">Objetivos de la siguiente visita</label>
                        <app-form-textarea-input
                            id="objetives"
                            size="sm"
                            v-model="commercialInfo.objetives"
                        ></app-form-textarea-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="provider">Proveedor actual</label>
                        <app-form-textarea-input
                            id="provider"
                            type="text"
                            size="sm"
                            v-model="commercialInfo.currentProvider"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="description">Descripción del prospecto</label>
                        <app-form-textarea-input
                            id="description"
                            size="sm"
                            v-model="commercialInfo.description"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="tools">Herramienta o equipos</label>
                        <app-form-textarea-input
                            id="tools"
                            size="sm"
                            v-model="commercialInfo.toolsOrEquipment"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="strategy">Estrategia</label>
                        <app-form-textarea-input
                            id="strategy"
                            size="sm"
                            v-model="commercialInfo.strategy"
                        ></app-form-textarea-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            label="Facturación estimada al año"
                            type="number"
                            size="sm"
                            v-model="commercialInfo.estimatedBillToYear"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            label="Inversión estimada"
                            type="number"
                            size="sm"
                            v-model="commercialInfo.estimatedInvestment"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            label="Inversión operativa estimada"
                            type="number"
                            size="sm"
                            v-model="commercialInfo.operationalInvestment"
                        ></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <app-form-text-input
                            label="Probabilidad de ganar"
                            type="number"
                            step="0.01"
                            size="sm"
                            v-model="commercialInfo.probabilityOfWinning"
                        ></app-form-text-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="aspects">Aspectos relevantes para la propuesta</label>
                        <app-form-textarea-input
                            id="aspects"
                            size="sm"
                            v-model="commercialInfo.relevantAspects"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="visitPlanning">Planeación de la visita</label>
                        <app-form-textarea-input
                            class="mt-3"
                            id="visitPlanning"
                            size="sm"
                            v-model="commercialInfo.visitPlanning"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12" md="3" class="py-2">
                        <label for="results">Razones de ganancia o perdida</label>
                        <app-form-textarea-input
                            class="mt-3"
                            id="results"
                            size="sm"
                            v-model="commercialInfo.results"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="3" class="py-2">
                        <label for="type">Fase del proceso</label>
                        <app-form-select-input
                            class="mt-3"
                            size="sm"
                            :options="phases"
                            id="type"
                            v-model="commercialInfo.phaseId"
                        ></app-form-select-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="3" class="py-2">
                        <label for="type">Perfil del contacto</label>
                        <app-form-select-input
                            size="sm"
                            :options="contactProfiles"
                            id="type"
                            v-model="commercialInfo.contactProfileId"
                        ></app-form-select-input>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col cols="12" md="4">
                        <b-btn
                            block
                            size="sm"
                            title="Limpiar campos"
                            @click="$router.push({ name: 'clientsPage' })"
                        >Diligenciar en otro momento</b-btn>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-btn
                            block
                            size="sm"
                            variant="primary"
                            title="Guardar datos"
                            @click="saveCommercialInfo()"
                        >
                            <i class="fa fa-save" aria-hidden="true"></i>
                            Guardar
                        </b-btn>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    props: ['clientId', 'name', 'theCommercialInfo'],
    data: () => ({
        commercialInfo: {
            mainContact: '',
            workPosition: '',
            description: '',
            contactProfile: '',
            reasonForPurchase: '',
            managementPerformed: '',
            nextStepProcess: '',
            objetives: '',
            currentProvider: '',
            probableStartDate: '',
            proposalDeliveryDate: '',
            strategy: '',
            estimatedBillToYear: '',
            estimatedInvestment: '',
            operationalInvestment: '',
            probabilityOfWinning: '',
            relevantAspects: '',
            visitPlanning: '',
            toolsOrEquipment: '',
            results: '',
            phaseId: '',
            contactProfileId: '',
        },
        clientName: '',
        editing: false,
        globalId: '',
        phases: [],
        contactProfiles: [],
    }),
    methods: {
        fill(item) {
            this.commercialInfo.contactProfileId = item.contact_profile_id
            this.commercialInfo.phaseId = item.commercial_phase_id
            this.commercialInfo.mainContact = item.main_contact
            this.commercialInfo.workPosition = item.work_position
            this.commercialInfo.description = item.description
            this.commercialInfo.contactProfile = item.contact_profile
            this.commercialInfo.reasonForPurchase = item.reason_for_purchase
            this.commercialInfo.managementPerformed = item.management_performed
            this.commercialInfo.nextStepProcess = item.next_step_process
            this.commercialInfo.objetives = item.objetives_next_visit
            this.commercialInfo.currentProvider = item.current_provider
            this.commercialInfo.probableStartDate = item.probable_start_date
            this.commercialInfo.proposalDeliveryDate =
                item.proposal_delivery_date
            this.commercialInfo.strategy = item.strategy

            !!item.estimated_bill_to_year &&
                (this.commercialInfo.estimatedBillToYear = `${item.estimated_bill_to_year}`)
            !!item.estimated_investment &&
                (this.commercialInfo.estimatedInvestment = `${item.estimated_investment}`)
            !!item.operational_investment &&
                (this.commercialInfo.operationalInvestment = `${item.operational_investment}`)
            !!item.probability_of_winning &&
                (this.commercialInfo.probabilityOfWinning = `${item.probability_of_winning}`)

            this.commercialInfo.relevantAspects = item.relevant_aspects
            this.commercialInfo.visitPlanning = item.visit_planning
            this.commercialInfo.toolsOrEquipment = item.tools_or_equipment
            this.commercialInfo.results = item.results
            this.editing = true
        },
        resetFields() {
            Object.keys(this.commercialInfo).map(
                key => (this.commercialInfo[key] = '')
            )
        },
        async saveCommercialInfo() {
            try {
                const { data } = !this.editing
                    ? await repo.post('clients/store-commercial-info', {
                          ...this.commercialInfo,
                          clientId: this.clientId,
                      })
                    : await repo.put(
                          `clients/${this.theCommercialInfo.client_id}/commercial-info`,
                          {
                              ...this.commercialInfo,
                              clientId: this.clientId,
                          }
                      )
                if (data.prospect && data.status) {
                    toastr.success(data.msg)
                    this.$router.push({
                        name: 'clientContactsPage',
                        params: {
                            prospectId: data.prospect.id,
                            prospect: true,
                            tabIndex: 8,
                        },
                    })
                } else {
                    toastr.error(data.msg)
                }
                this.reset()
            } catch (error) {
                this.$emit('error', error)
            }
        },
        async loadCommercialPhases() {
            const { data } = await repo.get('clients/commercial-phases')
            this.phases = data
        },
        async loadContactProfiles() {
            const { data } = await repo.get('clients/contact-profiles')
            this.contactProfiles = data
        },
    },
    mounted() {
        this.loadContactProfiles()
        this.loadCommercialPhases()
        if (!!this.theCommercialInfo) {
            this.fill(this.theCommercialInfo)
        }
        this.clientName = this.name ? this.name : ''
    },
}
</script>
